import React from 'react';

const NoMenuLayout = ({ children }) => <div className="ckp-layout ckp-layout-center">{children}</div>;

export default NoMenuLayout;



// WEBPACK FOOTER //
// ./src/components/application/layout/NoMenuLayout.js